export const experienceData = [
    {
        id: 1,
        company: 'Promikos',
        jobtitle: 'Junior Software Engineer',
        startYear: '2015',
        endYear: '2017'
    },
    {
        id: 2,
        company: 'Cubes',
        jobtitle: 'Full Stack Developer',
        startYear: '2024',
        endYear: '2017'
    },
    {
        id: 3,
        company: 'PETADATA',
        jobtitle: 'Senior Software Engineer',
        startYear: '2024',
        endYear: 'present'
    },
]